import React from 'react';
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./feminism.css";
import img from "./pics/journal.jpg"
import Comment from '../../components/Comment'
const Journal = () => {
    const prompts = [
        'Basic updates',
        'Plan for the next day',
        'Things you are grateful for',
        'Learnings of the day',
        'Positive Affirmations',
        'Childhood memories',
        'Your Goals',
        'Bucket list',
        'Your Passion',
        'People/Things you love',
      ];
  return  (
    <div className="article-container">
        <img src={Logoar} alt="Logoar" className="logoar" />
      <div className="blue-bg">
     
        {/* <h2 className="titleart">Modern Vanvas</h2> */}
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/articles" target='_blank' data-wpel-link="internal">Articles</a></h4>
		<h1 class="entry-title">Dear Diary</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Harshala</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">11.01.2024</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
    
 <br/>
  <img src={img} alt="Logoar" className="mo" />

        <div className="description1-5">
        
        <p>"My most loyal companion? Not a person, but my confidant with no judgment, impeccable secrecy, and superb listening skills—my BFF, Dear Diary! It turns out, the pen is mightier than gossip, and my diary is the MVP of keeping secrets, drama-free zones, and being the friend who never interrupts."</p>

<p>Journaling has been a treasured part of my life ever since sixth grade. Initially, my entries chronicled the small quirks of daily life – from friends nabbing my pencils to my antics with teachers. It was akin to Betty's yearly journals in Riverdale, a record of my everyday escapades. But it wasn’t until ninth grade, thanks to a counselor's advice, that my journaling took on a deeper, more profound purpose.</p>

<p>She said, “Let your diary carry what burdens you,” and that hit me.</p>

<p>The mention of journaling often brings to mind the powerful story of "Diary of a Young Girl." For those unfamiliar, it chronicles the life of Anne Frank, a girl living during the tumultuous era of World War II. Her journal became a steadfast companion through the harrowing times of hiding during the war. Published by her father, the sole survivor of their family, this ordinary schoolgirl's journal transformed into a remarkable bestseller. The journey of her diary's publication illustrates the incredible potency inherent in the act of journaling itself. It underscores how a personal chronicle can transcend its origins to touch the hearts and minds of countless readers, resonating across generations and cultures.</p>

<p>Journaling, as I mentioned, is recommended by counselors because it reduces stress. Also, at times when you don't have clarity over things, writing down everything helps get a better picture and improves the clarity over the situation.</p>

<p>Beyond its therapeutic benefits, journaling is a mirror for self-reflection, fostering self-awareness and comfort within oneself. It's the solace when words can't find ears to trust or hearts to confide in. It cradles our darkest thoughts, life updates, and aspirations alike.</p>

<p>Sometimes we confront thoughts or feelings too personal for sharing or struggle to find someone available to confide in. The common advice to "always reach out" feels hollow when there's hardly anyone to turn to. In these moments, our diary or journal becomes an invaluable confidant. It stands ready to embrace our deepest thoughts, life updates, and aspirations without judgment or reservation. Whether it's your darkest thoughts or the brightest dreams, our journal remains a faithful keeper of our inner world.</p>

<p>This article is your sign to start journaling and improve your life. Perhaps dedicate 10-20 minutes before bedtime to this practice.</p>

<div>
      <h3>Here are a few prompts that you can use:</h3>
      <ul>
        {prompts.map(prompt => (
          <li key={prompt}>{prompt}</li>
        ))}
      </ul>
    </div>
<p>Journaling isn't just about writing; it's about unraveling the layers of our existence, finding solace, and forging a deeper connection with ourselves.</p>




    <hr></hr>
</div>

        <Share/>
      </div>
</div> )}

export default Journal;